module.exports = __webpack_public_path__ + "media/Depositphotos_151324262_1080p.1cfa1632.mp4";